export default function PHP_is_iterable() {
  return (
    <div>
      <h1>PHP_is_iterable</h1>
    </div>
  );
}
